<template>
  <header>
    <div class="affix-head py-3 wow fadeInDown">
      <div class="container">
        <div class="row">
          <div class="col-2 col-md-3 d-lg-none">
            <div
              class="click_menu text-white d-inline pt-3"
              v-on:click="isActive = !isActive"
              v-bind:class="{ active: isActive }"
            >
              <i class="fas fa-bars"></i>
            </div>
          </div>
          <div class="col-3 col-md-2">
            <router-link to="/">
              <img
                src="../assets/logo.png"
                class="mw-100"
                alt="thong firearms"
              />
            </router-link>
          </div>
          <div class="col-6 d-lg-block d-none">
            <nav class="h-100">
              <ul class="h-100 align-items-center">
                <li>
                  <router-link to="/">หน้าแรก</router-link>
                </li>
                <li>
                  <router-link to="/about-us">เกี่ยวกับเรา</router-link>
                </li>
                <li>
                  <router-link to="/license">การขอใบอนุญาตซื้อปืน</router-link>
                </li>
                <li>
                  <router-link to="/contact-us">ติดต่อเรา</router-link>
                </li>
              </ul>
            </nav>
          </div>
          <div class="col-4 d-lg-block d-none">
            <nav class="h-100">
              <ul class="text-right h-100 align-items-center">
                <li v-for="(item, index) in categorys" :key="item.id">
                  <router-link :to="'/category/' + (index + 1)">{{
                    item
                  }}</router-link>
                </li>
                <!-- <li>
                  <router-link :to="'/welfare'"
                    >ปืนสั้นสวัสดิการกรมการปกครอง</router-link
                  >
                </li> -->
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </div>
    <div class="menu-top">
      <div class="container">
        <div class="row justify-content-between">
          <div class="col-lg-6 col-md-6 d-lg-block d-none">
            <nav>
              <ul>
                <li>
                  <router-link to="/">หน้าแรก</router-link>
                </li>
                <li>
                  <router-link to="/about-us">เกี่ยวกับเรา</router-link>
                </li>
                <li>
                  <router-link to="/license"
                    >การขอใบ ป.3 (อนุญาตซื้อปืน)</router-link
                  >
                </li>
                <li>
                  <router-link to="/contact-us">ติดต่อเรา</router-link>
                </li>
              </ul>
            </nav>
          </div>
          <div class="d-lg-block d-none col-md-2 text-right">
            <nav>
              <ul>
                <li v-for="(item, index) in categorys" :key="item.id">
                  <router-link :to="'/category/' + (index + 1)">{{
                    item
                  }}</router-link>
                </li>
                <!-- <li>
                  <router-link :to="'/welfare'"
                    >ปืนสั้นสวัสดิการกรมการปกครอง</router-link
                  >
                </li> -->
              </ul>
            </nav>
          </div>
          <div class="col-12 d-lg-none text-light">
            <div
              class="click_menu d-inline"
              v-on:click="isActive = !isActive"
              v-bind:class="{ active: isActive }"
            >
              <i class="fas fa-bars"></i>
            </div>
            <div class="menu-mobile fixed-top">
              <nav>
                <ul>
                  <li class="py-3 text-center">
                    <router-link to="/">
                      <img src="../assets/logo.png" alt="thong firearms" />
                    </router-link>
                    <div
                      class="btn-close"
                      v-on:click="isActive = !isActive"
                      v-bind:class="{ active: isActive }"
                    >
                      <i class="fas fa-times"></i>
                    </div>
                  </li>
                  <li v-on:click="isActive = !isActive">
                    <router-link to="/">หน้าแรก</router-link>
                  </li>
                  <li v-on:click="isActive = !isActive">
                    <router-link to="/about-us">เกี่ยวกับเรา</router-link>
                  </li>
                  <li
                    v-on:click="showSub = !showSub"
                    v-bind:class="{ active: showSub }"
                  >
                    <a href="#">สินค้า</a>
                    <ul>
                      <li v-on:click="isActive = !isActive">
                        <router-link to="/category/1">ปืนสั้น</router-link>
                      </li>
                      <li v-on:click="isActive = !isActive">
                        <router-link to="/category/2">ปืนยาว</router-link>
                      </li>
                      <!-- <li v-on:click="isActive = !isActive">
                        <router-link to="/welfare"
                          >ปืนสั้นสวัสดิการกรมการปกครอง</router-link
                        >
                      </li> -->
                    </ul>
                  </li>
                  <li v-on:click="isActive = !isActive">
                    <router-link to="/license"
                      >การขอใบ ป.3 (อนุญาตซื้อปืน)</router-link
                    >
                  </li>
                  <li v-on:click="isActive = !isActive">
                    <router-link to="/contact-us">ติดต่อเรา</router-link>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="row">
        <div
          class="col-lg-3 col-sm-12 col-xs-12 pt-3 pb-1 max-width text-center text-lg-left"
        >
          <router-link to="/">
            <img src="../assets/logo.png" alt="thong firearms" />
          </router-link>
        </div>
        <div
          class="col-lg-6 col-sm-12 col-xs-12 my-2 my-lg-0 text-white d-flex align-items-center justify-content-center justify-content-lg-end display-4 contact-top"
        >
          <i class="margin-top-6 fas fa-phone-volume"></i> &nbsp;
          <a class="tel" href="tel:+6626239838">02-623-9838</a>,&nbsp;
          <a class="tel" href="tel:+6622227784">02-222-7784</a>
          <!-- ,&nbsp;<a class="tel" href="tel:+66651989891">065-198-9891</a> -->
        </div>
        <div
          class="col-lg-3 col-sm-12 col-xs-12 my-2 my-lg-0 d-flex align-items-center justify-content-center justify-content-md-end"
        >
          <div class="position-relative mb-3 mb-lg-0 width-100">
            <form @submit.prevent="searchForm">
              <label for="search" hidden>ค้นหาปืน</label>
              <input
                type="text"
                id="search"
                class="search"
                placeholder="ค้นหาชื่อปืน/รุ่น"
                v-model="search"
              />
              <button type="submit" class="position-absolute icon-search">
                <i class="fas fa-search"></i>
              </button>
            </form>
          </div>
        </div>
        <!-- old nav position -->
      </div>
    </div>
    <div class="col-lg-12 pt-3 d-lg-block d-none">
      <nav class="category-gun">
        <ul class="text-center">
          <li v-for="(item, index) in brands" :key="index" v-if="item != ''">
            <router-link v-bind:to="'/brand/' + item.id">{{
              item.val
            }}</router-link>
          </li>
        </ul>
      </nav>
    </div>
  </header>
</template>

<script>
window.onscroll = function() {
  if (window.pageYOffset > 200) {
    $(".affix-head").addClass("fixed");
  } else {
    $(".affix-head").removeClass("fixed");
  }
};

export default {
  data() {
    return {
      fixed: "",
      search: "",
      isActive: false,
      showSub: false,
      categorys: ["ปืนสั้น", "ปืนยาว"],
      brands: [
        // { id: 13, val: "BAIKAL" },
        { id: 1, val: "BENELLI" },
        "",
        // { id: 14, val: "CMMG" },
        "",
        // { id: 21, val: "BUL Armory" },
        "",
        { id: 4, val: "COLT" },
        { id: 5, val: "CZ" },
        { id: 16, val: "DERYA" },
        { id: 6, val: "GLOCK" },
        // { id: 18, val: "I.C.R.W." },
        { id: 20, val: "MAXIM DEFENSE" },
        // { id: 19, val: "MOSSBERG" },
        { id: 23, val: "PHOENIX TRINITY" },
        // { id: 7, val: "HENRY" },
        // { id: 8, val: "REMINGTON" },
        { id: 22, val: "SIG SAUER" },
        { id: 9, val: "SMITH&WESSON" },
        { id: 17, val: "STACCATO" },
        // { id: 10, val: "STANDARD MFG. (U.S.A.)" },
        { id: 15, val: "TippMann" },
        { id: 12, val: "Zev Technologies" },
        { id: 11, val: "TARAN TACTICAL INNOVATIONS JOHN WICK" }
      ]
    };
  },
  methods: {
    toggleMenu: function() {
      this.isActive = !this.isActive;
    },
    toggleSub: function() {
      this.showSub = !this.showSub;
    },
    searchForm: function() {
      //console.log(this.search)
      //this.search = '';
      this.$router.push("/search/" + this.search);
    }
  }
};
</script>

<style scoped>
.affix-head {
  display: none;
  position: fixed;
  -webkit-transition: all 0.5s;
  transition: 0.5s all;
  top: -200px;
}
.affix-head.fixed {
  display: block;
  width: 100%;
  background: #000;
  z-index: 20;
  left: 0;
  top: 0px;
  -webkit-transition: all 0.5s ease;
  transition: 0.5s all ease;
}
.affix-head.fixed img {
  -webkit-transition: all 0.5s ease;
  transition: 0.5s all ease;
  width: 35%;
}
li a,
.click_menu,
.btn-close {
  cursor: pointer;
}
.btn-close {
  position: absolute;
  top: 25px;
  right: 25px;
}
.margin-top-6 {
  margin-top: -7px;
}
.click_menu.active ~ .menu-mobile {
  left: 0;
}
.menu-mobile {
  left: -100%;
  transition: all 0.3s;
  -webkit-transition: all 0.3s;
}
.menu-mobile ul {
  display: block;
  margin: 0;
}
.menu-mobile ul li:first-child {
  padding-left: 0;
}
.menu-mobile ul li {
  border-bottom: 1px solid rgb(49, 49, 49);
  padding-left: 25px;
  padding-top: 15px;
  padding-bottom: 15px;
  font-size: 20px;
}
.menu-mobile {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 1);
}
.menu-mobile img {
  width: 60%;
}
.close-menu-mobile {
  width: 10%;
  height: 100%;
  right: 0;
}
.menu-mobile ul li > ul {
  padding: 0;
  display: none;
}
.menu-mobile ul li.active > ul {
  display: block;
}
.menu-mobile ul li > ul > li:first-child {
  padding-left: 15px;
}
.menu-mobile ul li > ul > li {
  padding-left: 15px;
  list-style: none;
  border-bottom: 0;
  font-size: 16px;
  padding-top: 10px;
  padding-bottom: 10px;
}

.menu-mobile ul li > ul > li > a {
  color: #fff;
  display: block;
}
.category-gun ul > li {
  margin-right: 5px;
  background: #000;
  padding: 10px 0;
}
.category-gun ul > li:last-child {
  margin-right: 0;
}
.icon-search:hover {
  cursor: pointer;
  color: #fff;
}
.icon-search {
  top: 5px;
  right: 15px;
  background: transparent;
  border: 0;
  color: #666;
  transition: 0.5s all;
}
.contact-top {
  font-size: 20px;
}
.tel {
  color: #fff;
}
.tel:hover {
  color: #ffeeee;
  text-decoration: none;
}

.search {
  color: #ddd;
}
input[type="text"]::-webkit-input-placeholder {
  /* Chrome/Opera/Safari */
  color: #666;
}
input[type="text"]::-moz-placeholder {
  /* Firefox 19+ */
  color: #666;
}
input[type="text"]:-ms-input-placeholder {
  /* IE 10+ */
  color: #666;
}
input[type="text"]:-moz-placeholder {
  /* Firefox 18- */
  color: #666;
}
input[type="text"] {
  background: #292929;
  border: 0;
  height: 35px;
  padding: 5px 15px;
}
.menu-top {
  background: #000;
  padding: 10px 0;
}
nav > ul {
  padding: 0;
  margin: 0;
  display: flex;
}
nav > ul > li {
  list-style: none;
  flex-grow: 1;
}
nav > ul > li > a {
  color: #fff;
}
header {
  background: #111;
}
@media screen and (min-width: 100px) and (max-width: 1024px) {
  .contact-top {
    font-size: 16px;
  }
  .affix-head.fixed img.mw-100 {
    width: 150px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/component/header.vue